export const POSTHOG_UI_HOST = "https://us.posthog.com"
export const POSTHOG_DEFAULTS_DATE = "2026-05-30"

export function getPageViewCaptureDecision({
  currentUrl,
  hasHandledInitialPageView,
  initialPageViewUrl,
}: {
  currentUrl: string
  hasHandledInitialPageView: boolean
  initialPageViewUrl: string | null
}) {
  return {
    capture: hasHandledInitialPageView || currentUrl !== initialPageViewUrl,
    hasHandledInitialPageView: true,
  }
}

export function runOnce<TArgs extends unknown[]>(
  callback: (...args: TArgs) => void
) {
  let hasRun = false

  return (...args: TArgs) => {
    if (hasRun) {
      return
    }

    hasRun = true
    callback(...args)
  }
}
